export default __webpack_public_path__ + "static/media/Wrap of Dragon Flight.3dd7ff90.jpg";